// 모바일 사이드바 열림 상태 + 장바구니 zustand 스토어 (전 지점 공용)
//
// persist 키("cart-storage")와 version(2)은 절대 바꾸지 말 것 —
// 변경 시 기존 방문자의 localStorage 장바구니가 유실된다.
//
// guro.bypltt 는 normalizeId/createJSONStorage 를 얹은 확장판을 별도 유지하므로
// 이 스토어를 쓰지 않는다.
import { create } from "zustand";
import { persist } from "zustand/middleware";

/* ===== 사이드바 열림 상태 ===== */
export const useMobileSidebarState = create((set) => ({
  isOpen: false,
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  setIsOpen: (isOpen) => set({ isOpen }),
}));

/* ===== 장바구니 키 유틸: 전역 유일키 생성 ===== */
const keyOf = (it) => {
  if (!it) return null;
  if (it._detailKey) return String(it._detailKey);
  if (it.productId != null && it.detailId != null) {
    return `${String(it.productId)}::${String(it.detailId)}`;
  }
  return null; // 키를 만들 수 없으면 null
};

/* ===== 장바구니 스토어 ===== */
export const cartState = create(
  persist(
    (set, get) => ({
      cart: [],

      // 담기: 같은 키가 이미 있으면 무시
      addToCart: (item) =>
        set((state) => {
          const k = keyOf(item);
          const newItem = k ? { ...item, _detailKey: k } : item;

          const exists = k
            ? state.cart.some((x) => keyOf(x) === k)
            : state.cart.some((x) => x.name === item?.name); // (레거시 대비 마지막 안전망)

          if (exists) return state;
          return { cart: [...state.cart, newItem] };
        }),

      // 빼기: 문자열 키 or 객체 모두 지원
      removeFromCart: (arg) =>
        set((state) => {
          const k = typeof arg === "string" ? arg : keyOf(arg);
          if (k) {
            return { cart: state.cart.filter((x) => keyOf(x) !== k) };
          }
          // 키가 없으면 레거시 fallback: name 기준
          const name = typeof arg === "object" ? arg?.name : null;
          if (name) {
            return { cart: state.cart.filter((x) => x.name !== name) };
          }
          return state;
        }),

      // 유틸
      clearCart: () => set({ cart: [] }),

      // 레거시 아이템에 _detailKey 보정
      migrateKeys: () =>
        set((state) => ({
          cart: state.cart.map((x) =>
            keyOf(x) ? { ...x, _detailKey: keyOf(x) } : x
          ),
        })),
    }),
    {
      name: "cart-storage",
      version: 2, // ⬅️ 버전 올려 마이그레이션 트리거
      migrate: (persisted, version) => {
        const state = persisted?.state ?? { cart: [] };
        // v1 -> v2: _detailKey 채워넣기
        const cart = (state.cart || []).map((x) =>
          keyOf(x) ? { ...x, _detailKey: keyOf(x) } : x
        );
        return { ...state, cart };
      },
    }
  )
);
